export const WxAssertBasicUrl = 'https://public.qiniu.xcims.com/'
export const WxShopActMusicUrl = 'https://public.qiniu.xcims.com/wx_shopact.mp3' // 微信店铺活动的音乐
